import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { TypographyT36 } from "Components/Common/Typography/index";
import { Spacer } from "Components/Common/Spacer/index";
import { FlexWrapperT2 } from "Components/Common/Wrapper/FlexWrapper";
import { ButtonT11 } from "Components/Common/Button/index";
const ModalCardT4 = (props) => {
  const {
    children,
    title,
    handleOnClickForDownloadBtn
  } = props;

  return (
    <Fragment>
      <ModalCardT1Wrapper>
        <FlexWrapperT2>
          <TypographyT36>{title}</TypographyT36>
          <ButtonT11
            onClick={() => {
              handleOnClickForDownloadBtn()
            }}
          >
            Download 
          </ButtonT11>
        </FlexWrapperT2>
        <Spacer spacing={"6px"} />
        {children}
      </ModalCardT1Wrapper>
    </Fragment>
  );
};

export default ModalCardT4;

const ModalCardT1Wrapper = styled.div`
  border-radius: 8px;
  background: #f6f9ff;
  padding: 20px 24px;
`;
